module.exports = __webpack_public_path__ + "static/media/shine&kristall.83eb8f0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/sections/Section-Stories/assets/shine&kristall.png
// module id = 244
// module chunks = 0